export const PATH = {
    SIMPAYX_NEW_ORDER_SOUND : 'assets/sounds/ubSound.mp3',
    GOOGLE_MAPS_REDIRECT : 'https://www.google.com/maps/dir/?api=1&origin=My+Location&destination=',
}